import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space, Modal, Select, Input, Badge } from "antd";
import { faFilter, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TobNavBar from "../DashBaord/Top_navbar";
import moment from "moment";
import { Link } from "react-router-dom";
import { ASSETS_BASE_URL } from "../../config/constants";
import { DeleteOutlined, EyeOutlined, MessageOutlined, SearchOutlined } from "@ant-design/icons";
import SkeltonList from "../../components/SkeltonEffect/list";
import { careerAppliedlist, deleteOneCareerApplication, updateApplicationStatus, addApplicationComment } from "../../controllers/submissions/submissionController";
import { getPage } from "../../controllers/common";
import * as XLSX from 'xlsx';

const STATUS_OPTIONS = [
  { value: "Applied", color: "#6c757d" },
  { value: "Under Review", color: "#0d6efd" },
  { value: "Screened", color: "#6f42c1" },
  { value: "Interviewed", color: "#c9891f" },
  { value: "Shortlisted", color: "#1d7a9c" },
  { value: "Offered", color: "#198754" },
  { value: "Rejected", color: "#dc3545" },
  { value: "Withdrawn", color: "#9a1d2e" },
];

const PAGE_SIZE = 10;

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [popUpOpen, setPopUpOpen] = useState(false);
  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => {
    setFilterShow(!isFilterShow);
  }

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const [exportLoadingText, setExportLoadingText] = useState(false);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [ALLLISTDATA, setListData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState([]);
  const [fileUrl, setFileUrl] = React.useState(null);
  console.log(fileUrl,"fileUrl")
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End
  const [showRequest, setShowRequest] = useState("");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isCommentDrawerOpen, setCommentDrawerOpen] = useState(false);
  const [commentTarget, setCommentTarget] = useState(null);
  const [newCommentText, setNewCommentText] = useState("");
  const [isCommentSubmitting, setIsCommentSubmitting] = useState(false);

  const handleExportPopup = () => {
    setIsExportModalOpen(true);
  }
  const handleExportCancel = () => {
    setIsExportModalOpen(false);
  };

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(showRequest ? { status: showRequest } : null),
        },
        ...(filter ? { filter: filter } : null),
        select: {},
        populate: {
          key: "Job_Id",
          select: "job_title"
        },
        sort: { status: 1, _id: -1 },
        // No skip/limit here -- the whole matching set is fetched once so the
        // on-screen search box below can filter across every row instantly;
        // pagination (PAGE_SIZE) is then applied client-side.
      };
      const listData = await careerAppliedlist(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setIsLoading(false);
        } else {
          setListData([]);
          setIsLoading(false);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleInputChange = (e) => {
    if (e.target.name === 'startdate') {
      setStartDate(e.target.value);
    } else if (e.target.name === 'enddate') {
      setEndDate(e.target.value);
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is use to delete partner
   *********************************************************/
  const handleDelete = async (deleteId) => {
    try {
      if (deleteId) {
        const options = { id: deleteId };
        const res = await deleteOneCareerApplication(options);
        if (res.status === true) {
          notification.open({
            message: "Deleted!",
            description: "Data Deleted Successfully.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "green" }} />,
          });
        } else {
          notification.open({
            message: "Oops!!",
            description: "Please try again.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "red" }} />,
          });
        }
      } else {
        notification.open({
          message: "Error",
          description: "Data Not Found! Try Again.",
          placement: "topRight",
          duration: 2,
          icon: <DeleteOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      notification.open({
        message: "Error",
        description: "An error occurred while deleting. Please try again.",
        placement: "topRight",
        duration: 2,
        icon: <DeleteOutlined style={{ color: "red" }} />,
      });
    }
    getList();
  };

  /*********************************************************
   *  This function is use to update an application's pipeline status
   *********************************************************/
  const handleStatusChange = async (id, newStatus) => {
    const previous = ALLLISTDATA;
    setListData((prev) => prev.map((it) => (it._id === id ? { ...it, applicationStatus: newStatus } : it)));
    try {
      const res = await updateApplicationStatus({ id, status: newStatus });
      if (res.status === true) {
        notification.open({
          message: "Updated!",
          description: "Application status updated.",
          placement: "topRight",
          duration: 2,
        });
      } else {
        setListData(previous);
        notification.open({
          message: "Oops!!",
          description: res.message || "Please try again.",
          placement: "topRight",
          duration: 2,
        });
      }
    } catch (error) {
      setListData(previous);
      notification.open({
        message: "Error",
        description: "An error occurred while updating status. Please try again.",
        placement: "topRight",
        duration: 2,
      });
    }
  };

  /*********************************************************
   *  These functions handle the right-side comment history panel
   *********************************************************/
  const openCommentDrawer = (item) => {
    setCommentTarget(item);
    setNewCommentText("");
    setCommentDrawerOpen(true);
  };

  const closeCommentDrawer = () => {
    setCommentDrawerOpen(false);
    setCommentTarget(null);
    setNewCommentText("");
  };

  const handleAddComment = async () => {
    if (!commentTarget || !newCommentText.trim()) return;
    setIsCommentSubmitting(true);
    try {
      const res = await addApplicationComment({ id: commentTarget._id, comment: newCommentText.trim() });
      if (res.status === true) {
        const updatedComments = res.result?.comments || [];
        setListData((prev) => prev.map((it) => (it._id === commentTarget._id ? { ...it, comments: updatedComments } : it)));
        setCommentTarget((prev) => (prev ? { ...prev, comments: updatedComments } : prev));
        setNewCommentText("");
      } else {
        notification.open({
          message: "Oops!!",
          description: res.message || "Please try again.",
          placement: "topRight",
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Error",
        description: "An error occurred while adding the comment. Please try again.",
        placement: "topRight",
        duration: 2,
      });
    } finally {
      setIsCommentSubmitting(false);
    }
  };

  const handleExportBWDates = async () => {
    setIsExportLoading(true);
    setExportLoadingText('Loading Data....');
    try {
      let isValidate = true;
      if (isValidate) {
        const exportOptions = {
          type: "",
          condition: {
            status: 'A',
            ...(startDate || endDate ? {
              createdAt: {
                ...(startDate ? { $gt: startDate } : {}),
                ...(endDate ? { $lt: endDate } : {}),
              },
            } : {}),
          },
        };
        const exportDatas = await careerAppliedlist(exportOptions);
        console.log('API res time bat', exportDatas);
        if (exportDatas.status === true) {
          if (exportDatas?.result.length > 0) {
            prepareSheetData(exportDatas?.result);
          } else {
            alert('No data found');
          }
        } else {
          setIsExportLoading(false);
          console.log('api error');
        }
      } else {
        setIsExportLoading(false);
        console.log('not validated');
      }
    } catch (error) {
      setIsExportLoading(false);
      console.log("error", error);
    } finally {
      setIsExportLoading(false);
    }
  }

  /*********************** Get data for export to excel *********************** */
  const getExcelExportData = async () => {
    try {
      setIsExportLoading(true);
      setExportLoadingText('Loading Data....');
      const exportOptions = {
        type: "",
        condition: {
          status: 'A',
        },
      };
      const exportData = await careerAppliedlist(exportOptions);
      console.log('API res', exportData);
      if (exportData.status === true) {
        if (exportData?.result.length > 0) {
          prepareSheetData(exportData?.result);
        } else {
          alert('No data found');
        }
      } else {
        setIsExportLoading(false);
        console.log('api error');
      }
    } catch (error) {
      console.log('error', error);
    }
  }; //End

  const prepareSheetData = (data) => {
    console.log('dataCount -', data.length);
    setExportLoadingText('Preparing Your Data....');
    const mySheet = data.map((items) => {
      console.log('items',items)
      console.log('items JobId',items[0]?.jobId)
      return {
        "Name": items?.name || '',
        "Job Id": items?.JobId || '',
        "Email": items?.email || '',
        "Mobile": items?.mobile || '',
        "Address 1": items?.address1 || '',
        "Address 2": items?.address2 || '',
        "Applied Text": items?.applied_text || '',
        "City": items?.city || '',
        "Country": items?.country || '',
        "File": items?.file || '', // legacy single-resume field, kept for pre-revamp applications
        "Cover Letter": items?.coverLetterFile || '',
        "Resume": items?.resumeFile || items?.file || '',
        "Photo": items?.photoFile || '',
        "Message": items?.message || '',
        "pin_code": items?.pincode || '',
        "State": items?.state || '',
        "City": items?.city || '',
        "Status": items?.status || '',
        "Date": items?.createdAt || '',
        "Update Date": items?.updatedAt || '',
      }
    });
    // setDataSheet(mySheet);
    downloadExcel(mySheet);
    setIsExportLoading(false);
  }


  const downloadExcel = (dataSheet = []) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert data for each sheet
    const worksheet = XLSX.utils.json_to_sheet(dataSheet);

    // Append sheets to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

    // Trigger download
    XLSX.writeFile(workbook, "KC_High_JobApplication_List.xlsx");
  };
  const handleViewItem = (item) => {
    setModalData(item);
    setIsModalOpen(true);
  }


  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          <Menu.Item key="01" onClick={() => handleViewItem(items)}>
            <EyeOutlined />
            <span className="show_span_edit">View</span>
          </Menu.Item>
          <Menu.Item key="02" onClick={() => handleDelete(items?._id)}>
            <DeleteOutlined />
            <span className="show_span_edit">Delete</span>
          </Menu.Item>
        </Menu>
      </>
    );
  };

  /*********************************************************
  *  This function is ued for handle filter input chnage
  *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
    } catch (error) {

    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre) => ({
        ...pre,
        'filter_by': form.get('filter_by') || '',
        'search': form.get('search') || '',
      }))
      handleFiterDrawer();
      setCurrentPage(1);
    } catch (error) {
      console.log(error);
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState('');
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showpdfModal = (fileurl) => {
    setFileUrl(fileurl);
  };

  const modalStyle = {
    padding : "40px 0 0 0",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    borderRadius: "5px",
    overflow: "hidden",
    width: "80%",
    height: "80%",
  };
  
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = "KC High Admin || Job Application List";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRequest, filter]);

  // Instant search across every loaded row/column -- purely client-side over
  // the full fetched set (see the note in getList above), so it doesn't need
  // a server round-trip and jumps back to page 1 whenever the query changes.
  const searchedData = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    return ALLLISTDATA.filter((item) => {
      if (statusFilter && (item?.applicationStatus || "Applied") !== statusFilter) return false;
      if (!q) return true;
      return [
        item?.JobId,
        item?.Job_Id?.job_title,
        item?.name,
        item?.email,
        item?.mobile,
        item?.applicationStatus,
        item?.createdAt ? moment(item.createdAt).format("DD/MM/YYYY hh:mm A") : "",
      ].some((value) => String(value || "").toLowerCase().includes(q));
    });
  }, [ALLLISTDATA, search, statusFilter]);

  const pageData = React.useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return searchedData.slice(start, start + PAGE_SIZE);
  }, [searchedData, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, statusFilter]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Job Application List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div onClick={() => handleExportPopup()}>
                    <button type="button" class="btn btn-dark">
                      <FontAwesomeIcon icon="fa-regular fa-plus Promotions_faPlus_Squares" />
                      <span className="request_new_categories">Export to Excel</span>
                    </button>
                  </div>
                  <div className="fa_filter_rating_review filter_img_and_add_btn_main px-2">
                    <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        <FontAwesomeIcon icon={faFilter} /> Filters
                      </Link>
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <Select
                    allowClear
                    placeholder="Filter by status"
                    value={statusFilter || undefined}
                    onChange={(value) => setStatusFilter(value || "")}
                    style={{ width: 180 }}
                    options={STATUS_OPTIONS.map((s) => ({
                      value: s.value,
                      label: (
                        <span>
                          <span
                            style={{
                              display: "inline-block",
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor: s.color,
                              marginRight: 6,
                            }}
                          />
                          {s.value}
                        </span>
                      ),
                    }))}
                  />
                  <Input
                    allowClear
                    prefix={<SearchOutlined style={{ color: "#999" }} />}
                    placeholder="Search across all columns..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ maxWidth: 320, width: "100%" }}
                  />
                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body all_card_body_padding">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead className="all_table_form">
                            <tr>
                              <th>Status</th>
                              <th>S.No.</th>
                              <th>Job Id</th>
                              <th>Job Title</th>
                              <th>Name</th>
                              <th>Contact Info</th>
                              <th>Resume</th>
                              <th>Date</th>
                              <th>Comments</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pageData?.length > 0 ? (
                              pageData.map((items, index) => (
                                <>
                                  <tr key={items?._id || index}>
                                    <td>
                                      <Select
                                        size="small"
                                        value={items?.applicationStatus || "Applied"}
                                        style={{ width: 150 }}
                                        onChange={(value) => handleStatusChange(items?._id, value)}
                                        options={STATUS_OPTIONS.map((s) => ({
                                          value: s.value,
                                          label: (
                                            <span>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: 8,
                                                  height: 8,
                                                  borderRadius: "50%",
                                                  backgroundColor: s.color,
                                                  marginRight: 6,
                                                }}
                                              />
                                              {s.value}
                                            </span>
                                          ),
                                        }))}
                                      />
                                    </td>
                                    <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                    <td className="admin_user_list_date">{items?.JobId}</td>
                                    <td className="admin_user_list_date">{items?.Job_Id?.job_title}</td>
                                    <td className="admin_user_list_date">{items?.name}</td>
                                    <td className="admin_user_list_date">{items?.email} <br /> {items?.mobile}</td>
                                    <td className="admin_user_list_date">
                                      <button
                                        className="btn-danger btn inventory_save_button"
                                        onClick={() => showpdfModal(ASSETS_BASE_URL + (items?.resumeFile || items?.file))}
                                      >
                                        View
                                      </button>
                                    </td>
                                    {fileUrl && (
                                      <>
                                        <div style={modalStyle}>
                                          
                                          <span
                                            style={{
                                              position: "absolute",
                                              top: "0px",
                                              right: "6px",
                                              fontSize: "30px",
                                              cursor: "pointer",
                                              color: "#333",
                                            }}
                                            onClick={() => setFileUrl(null)}
                                          >
                                            &times;
                                          </span>

                                          <object
                                            data={fileUrl}
                                            type="application/pdf"
                                            width="100%"
                                            height="100%"
                                          >
                                            <p>
                                              Your browser does not support viewing this file.{" "}
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer" download="Custom_Document.pdf"> 
                                                Download it instead.
                                              </a>
                                            </p>
                                          </object>
                                        </div>
                                      </>
                                    )}
                                    <td className="admin_user_list_date">{moment(`${items.createdAt}`).format(
                                      "DD/MM/YYYY hh:mm A"
                                    )}</td>
                                    <td className="text-center">
                                      <Badge count={items?.comments?.length || 0} size="small" offset={[-4, 4]}>
                                        <Button
                                          shape="circle"
                                          icon={<MessageOutlined />}
                                          onClick={() => openCommentDrawer(items)}
                                        />
                                      </Badge>
                                    </td>
                                    <td>
                                      <Dropdown
                                        overlay={() => dropdownMenu(items)}
                                        placement="bottomLeft"
                                        arrow
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr>
                              <td colspan="10" className="img-center" >No data found !</td>
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            page={currentPage}
                            count={getPage(searchedData.length) || 1}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
          {/************************************* Export to excel popup popup************************************************/}
          <Modal open={isExportModalOpen} onCancel={handleExportCancel}
            footer={null}
            width={800}
          >
            <div className="row text-center">
              <div className="col-12">
                <h5>Export to Excel</h5>
                <hr></hr>
              </div>
            </div>
            {/* <div className="row text-center  mt-3">
              <div className="col-12" onClick={() => getExcelExportData()}>
                <button className="btn btn-primary">Export All</button>
              </div>
              <div className="col-12 mt-5">
                <h6>Or</h6>
              </div>
            </div> */}
            <div className="row text-center mt-3">
              <div className="form-group col-lg-6 col-md-6 col-6">
                <span>Select start date</span>
                <input
                  type="date"
                  name="startdate"
                  onChange={handleInputChange}
                  className="form-control store_input_field"
                />
                {error.startdate ? (
                  <p style={{ color: "red" }}>
                    {error.startdate}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group col-lg-6 col-md-6 col-6">
                <span>Select end date</span>
                <input
                  type="date"
                  name="enddate"
                  onChange={handleInputChange}
                  className="form-control store_input_field"
                />
                {error.enddate ? (
                  <p style={{ color: "red" }}>
                    {error.enddate}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-12 mt-3">
                <button className="btn btn-primary mt-2" onClick={handleExportBWDates}>Export</button>
                <p>Leave dates empty to export all.</p>
              </div>
            </div>
          </Modal>

          <Modal open={isModalOpen} onCancel={handleCancel}
            footer={null}
          ><div className="registration_details_main_div">
              <h5 className="text-center">{modalData?.Job_Id?.job_title} ({modalData?.JobId})</h5>
              <p><strong>Name</strong> : {modalData?.name}</p>
              <p><strong>Phone</strong> : {modalData?.mobile}</p>
              <p><strong>Email</strong> : {modalData?.email}</p>
              <p><strong>Message</strong> : {modalData?.message}</p>
              <p><strong>Address 1</strong> : {modalData?.address1}</p>
              <p><strong>Address 2</strong> : {modalData?.address2}</p>
              <p><strong>Pincode</strong> : {modalData?.pincode}</p>
              <p><strong>Country</strong> : {modalData?.country}</p>
              <p><strong>State</strong> : {modalData?.state}</p>
              <p><strong>City</strong> : {modalData?.city}</p>
              <p><strong>Received On</strong> : {moment(`${modalData.createdAt}`).format("DD/MM/YYYY hh:mm A")}</p>
              <div className="d-flex gap-2">
                {(modalData?.resumeFile || modalData?.file) && (
                  <Link to={ASSETS_BASE_URL + (modalData?.resumeFile || modalData?.file)} target="_blank"><button className="btn-danger btn inventory_save_button">View Resume</button></Link>
                )}
                {modalData?.coverLetterFile && (
                  <Link to={ASSETS_BASE_URL + modalData.coverLetterFile} target="_blank"><button className="btn-danger btn inventory_save_button">View Cover Letter</button></Link>
                )}
                {modalData?.photoFile && (
                  <Link to={ASSETS_BASE_URL + modalData.photoFile} target="_blank"><button className="btn-danger btn inventory_save_button">View Photo</button></Link>
                )}
              </div>
            </div>
          </Modal>
        </div>
      </div>
      <Drawer
        title="Job-Application Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset} style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='name' selected={filter?.filter_by === 'name' ? true : false}>Name</option>
                  <option value='email' selected={filter?.filter_by === 'email' ? true : false}>Email</option>
                  <option value='mobile' selected={filter?.filter_by === 'mobile' ? true : false}>Mobile</option>
                  <option value='JobId' selected={filter?.filter_by === 'JobId' ? true : false}>Job Id</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"
                  ref={inputRef2}
                />
              </div>
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>

      <Drawer
        title={commentTarget ? `Comments — ${commentTarget.name}` : "Comments"}
        placement="right"
        width={480}
        onClose={closeCommentDrawer}
        open={isCommentDrawerOpen}
      >
        <div className="job_comment_history" style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {commentTarget?.comments?.length > 0 ? (
            [...commentTarget.comments]
              .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
              .map((c, i) => (
                <div
                  key={i}
                  className="job_comment_item"
                  style={{ borderBottom: "1px solid #eee", padding: "10px 0" }}
                >
                  <div className="d-flex justify-content-between">
                    <strong>{c.name}</strong>
                    <span className="text-muted" style={{ fontSize: 12 }}>
                      {moment(c.createdAt).format("DD/MM/YYYY hh:mm A")}
                    </span>
                  </div>
                  <p style={{ marginBottom: 0, marginTop: 4 }}>{c.comment}</p>
                </div>
              ))
          ) : (
            <p className="text-muted">No comments yet.</p>
          )}
        </div>
        <div className="job_comment_add mt-3">
          <textarea
            className="form-control"
            rows={3}
            placeholder="Add a comment..."
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
          />
          <Button
            type="primary"
            className="mt-2"
            loading={isCommentSubmitting}
            disabled={!newCommentText.trim()}
            onClick={handleAddComment}
          >
            Add Comment
          </Button>
        </div>
      </Drawer>
    </>
  );
}
